import type { CartItem, ProductVariant } from '../../types/domain';

export const cartLineKey = (productId: string, variantId?: string) => `${productId}:${variantId ?? 'base'}`;
export const cartItemKey = (item: CartItem) => cartLineKey(item.product.id, item.variantId);
export const cartVariant = (item: CartItem): ProductVariant | undefined => item.variantId ? item.product.variants.find((variant) => variant.id === item.variantId) : undefined;
export const cartUnitPrice = (item: CartItem) => cartVariant(item)?.priceCents ?? item.product.priceCents;
export const cartUnitCost = (item: CartItem) => cartVariant(item)?.costCents ?? item.product.costCents;
export const cartSku = (item: CartItem) => cartVariant(item)?.sku || item.product.sku;
export const cartDisplayName = (item: CartItem) => {
  const variant = cartVariant(item);
  return variant ? `${item.product.name} · ${variant.name}` : item.product.name;
};
